import { ArrowForward } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { fadeInUp, tokens } from "../../../store/tokens";

const BrowseSkillItem = (props) => {
  const { skillsData } = props;
  const { action, skill_list, title } = skillsData || {};
  const navigate = useNavigate();

  return (
    <Stack
      spacing={1.5}
      sx={{
        padding: "15px",
        ...fadeInUp,
        animation: "fadeInUp .5s ease both",
      }}
    >
      <Typography
        sx={{
          fontFamily: tokens.font.heading,
          fontSize: "14pt",
          fontWeight: 700,
          color: tokens.color.ink,
        }}
      >
        {title}
      </Typography>

      {(skill_list ?? []).map((element, index) => (
        <Typography
          key={element.refer}
          onClick={() => navigate(`/${action}/${element.refer}`)}
          sx={{
            fontFamily: tokens.font.body,
            fontSize: "0.95rem",
            color: tokens.textOn.light.secondary,
            cursor: "pointer",
            width: "fit-content",
            transition: "color 0.2s ease, transform 0.2s ease",
            ...fadeInUp,
            animation: "fadeInUp .4s ease both",
            animationDelay: `${Math.min(index, 8) * 0.05}s`,
            "&:hover": {
              color: tokens.color.teal,
              transform: "translateX(4px)",
            },
          }}
        >
          {element.title}
        </Typography>
      ))}

      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        onClick={() => navigate(`/${action}`)}
        sx={{
          cursor: "pointer",
          width: "fit-content",
          mt: 0.5,
          "&:hover .browse-skill-arrow": {
            transform: "translateX(4px)",
          },
        }}
      >
        <Typography
          sx={{
            fontFamily: tokens.font.body,
            fontSize: "0.9rem",
            fontWeight: 600,
            color: tokens.color.teal,
          }}
        >
          View More
        </Typography>
        <ArrowForward
          className="browse-skill-arrow"
          sx={{
            fontSize: "1rem",
            color: tokens.color.teal,
            transition: "transform 0.2s ease",
          }}
        />
      </Stack>
    </Stack>
  );
};

export default BrowseSkillItem;